/** biome-ignore-all lint/style/useNamingConvention: TODO: Fix camel case for this file */
export const TAB_KEYS = {
  DELIVERY: 'Delivery',
  PICKUP: 'Pickup',
};

export const INITIAL_TRAILER_DETAILS = {
  Commodity: null,

  destLocations: [
    {
      originBookOks: 0,
      originBookWeight: 0,
      originETD: null,
      originFurn: 0,
      originLocationId: null,
      originMiscOks: 0,
      originMiscWeight: 0,
      originOLI: 0,
      originShipLocation: null,
      originSoftOks: 0,
      originSoftWeight: 0,
      originSpotDate: null,
    },
  ],
  emptyDate: null,
  entryDate: null,
  orgLocations: [
    {
      destinationBookOks: 0,
      destinationBookWeight: 0,
      destinationConsignee: null,
      destinationETA: null,
      destinationFurn: 0,
      destinationLocationId: null,
      destinationMiscOks: 0,
      destinationMiscWeight: 0,
      destinationOLI: 0,
      destinationSoftOks: 0,
      destinationSoftWeight: 0,
    },
  ],
  PartnerLocation: null,
  PickupRentalCompany: null,
  productType: null,
  selPartner: null,
  selTrailer: null,
  selYardValue: null,
  txtinvJusti: null,
  txtRSCM: null,
  txtSCS: null,
  txtUserName: null,
  UnitSize: null,
  unitEmpty: false,
};

export const REQUEST_TYPES = {
  INBOUND: { desc: 'Inbound', value: 'I' },
  OUTBOUND: { desc: 'Outbound', value: 'O' },
  TRANSFER: { desc: 'Transfer', value: 'T' },
};

export const TRAILER_STATUS = {
  ASSIGNED: 'ASN',
  BROKEN: 'BRK',
  PLANNED: 'PLN',
  RECEIVED: 'RECV',
  UNASSIGNED: 'UNAS',
  UNCONFIRMED: 'UNCN',
};

export const TRAILER_STATUS_CODE = {
  Empty: 'EMT',
  Loaded: 'LOD',
  Spotted: 'SPT',
};

export const STATUS_OPTIONS = [
  { label: 'Spotted', value: TRAILER_STATUS_CODE.Spotted },
  {
    label: 'Empty',
    value: TRAILER_STATUS_CODE.Empty,
  },
  {
    label: 'Loaded',
    value: TRAILER_STATUS_CODE.Loaded,
  },
  {
    label: 'In Transit',
    value: TRAILER_STATUS_CODE.InTransit,
  },
];
